import { api } from '../api';

// Get host profile
export const getHostProfile = async (userId) => {
  const result = await api.getHostProfile(userId);
  if (result.error) {
    return null;
  }
  return result.data;
};

// Create host profile (via backend API)
// This is handled by the backend to ensure proper role assignment

// Update host profile
export const updateHostProfile = async (userId, updates) => {
  const result = await api.updateHostProfile(userId, updates);
  if (result.error) {
    throw new Error(result.error);
  }
};

